import { Text } from '@/components/ui/text';
import Ionicons from '@expo/vector-icons/Ionicons';
import { Pressable, View } from 'react-native';
import type { Business } from '@/types/business';

interface BusinessContactSectionProps {
  business: Business;
  onWebsitePress: () => void;
  onPhonePress: () => void;
  onEmailPress: () => void;
}

export function BusinessContactSection({
  business,
  onWebsitePress,
  onPhonePress,
  onEmailPress,
}: BusinessContactSectionProps) {
  if (!business.website && !business.phone && !business.email) return null;

  return (
    <View className="mb-8 pb-4">
      <Text className="text-2xl font-semibold mb-3 text-foreground" accessibilityRole="header">
        Contact
      </Text>
      <View className="flex-row gap-2">
        {business.website && (
          <Pressable
            onPress={onWebsitePress}
            className="flex-1 flex-row items-center justify-center p-3 rounded-lg bg-surface border border-border"
            style={{ opacity: 0.95 }}
          >
            <Ionicons name="globe-outline" size={18} className="text-foreground" style={{ marginRight: 8 }} />
            <Text className="text-sm font-semibold text-foreground">Website</Text>
          </Pressable>
        )}
        {business.phone && (
          <Pressable
            onPress={onPhonePress}
            className="flex-1 flex-row items-center justify-center p-3 rounded-lg bg-surface border border-border"
            style={{ opacity: 0.95 }}
          >
            <Ionicons name="call-outline" size={18} className="text-foreground" style={{ marginRight: 8 }} />
            <Text className="text-sm font-semibold text-foreground">Call</Text>
          </Pressable>
        )}
        {business.email && (
          <Pressable
            onPress={onEmailPress}
            className="flex-1 flex-row items-center justify-center p-3 rounded-lg bg-surface border border-border"
            style={{ opacity: 0.95 }}
          >
            <Ionicons name="mail-outline" size={18} className="text-foreground" style={{ marginRight: 8 }} />
            <Text className="text-sm font-semibold text-foreground">Email</Text>
          </Pressable>
        )}
      </View>
    </View>
  );
}
